<template>
  <ul class="lte-timeline timeline">
    <slot></slot>
  </ul>
</template>
<script>
  export default {
    name: 'lte-timeline',
    props: {

    }
  };

</script>



// WEBPACK FOOTER //
// timeline.vue?08d676ac